/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Servis_S5_OutroInputs */

const tr_servis_s5_outro = /** @type {(inputs: Servis_S5_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Askıya alma süresi en fazla 30 gündür; bu süre içinde ihlal giderilmezse Sözleşme feshedilebilir.`)
};

const en_servis_s5_outro = /** @type {(inputs: Servis_S5_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The suspension period is at most 30 days; if the breach is not remedied within this period, the Agreement may be terminated.`)
};

const de_servis_s5_outro = /** @type {(inputs: Servis_S5_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Sperrdauer beträgt höchstens 30 Tage; wird der Verstoß in diesem Zeitraum nicht behoben, kann der Vertrag gekündigt werden.`)
};

const ru_servis_s5_outro = /** @type {(inputs: Servis_S5_OutroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок приостановки составляет не более 30 дней; если нарушение не устранено в этот срок, Договор может быть расторгнут.`)
};

/**
* | output |
* | --- |
* | "The suspension period is at most 30 days; if the breach is not remedied within this period, the Agreement may be terminated." |
*
* @param {Servis_S5_OutroInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const servis_s5_outro = /** @type {((inputs?: Servis_S5_OutroInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Servis_S5_OutroInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_servis_s5_outro(inputs)
	if (locale === "de") return de_servis_s5_outro(inputs)
	if (locale === "ru") return ru_servis_s5_outro(inputs)
	return tr_servis_s5_outro(inputs)
});